export default "__VITE_ASSET__e4d510c1__"